import { connect } from 'react-redux';

import {
    GridActionsMenu,
    GridActionsMenuProps
} from '../../components/GridActionsMenu/GridActionsMenu';
import { dealActionsMenuSelector } from '../../selectors/gridActionsMenu/gridActionsMenu';
import { DealItemAction } from '../../typings/deals';
import { State } from '../../typings/state';

export interface DealActionsMenuContainerProps {
    index: number;
    actions: DealItemAction;
}

const mapStateToPropsForDeals = (
    state: State,
    ownProps: DealActionsMenuContainerProps
): GridActionsMenuProps => {
    return dealActionsMenuSelector(state, ownProps);
};

const mergeProps = (stateProps: GridActionsMenuProps): GridActionsMenuProps => {
    return stateProps;
};

export const DealActionsMenuContainer = connect<
    GridActionsMenuProps,
    {},
    DealActionsMenuContainerProps,
    GridActionsMenuProps
>(
    mapStateToPropsForDeals,
    undefined,
    mergeProps
)(GridActionsMenu);
